module.exports = __webpack_public_path__ + "right.png?e74432e88b2bfc5395bce0ac2048f4c3";